import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type getUserIdentitiesResponse =
  paths['/api/v1/user_identities/me']['get']['responses']['200']['content']['application/json']['userIdentity'];

export type addUserIdentityBody = NonNullable<
  NonNullable<
    paths['/api/v1/user_identities']['post']['requestBody']
  >['content']['application/json']
>;
export type addUserIdentityResponse = NonNullable<
  paths['/api/v1/user_identities']['post']['responses']['200']['content']['application/json']
>;
export type errorResponse = NonNullable<
  paths['/api/v1/user_identities']['post']['responses']['400']['content']['application/json']
>;
export type addUserIdentityResult = {
  data: addUserIdentityResponse | undefined;
  error: errorResponse | undefined;
};

export async function getUserIdentities(): Promise<getUserIdentitiesResponse> {
  const { data, error } = await client.GET('/api/v1/user_identities/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserIdentities');
  return data.userIdentity;
}

export async function addUserIdentity(body: addUserIdentityBody): Promise<addUserIdentityResult> {
  const { data, error } = await client.POST('/api/v1/user_identities', {
    headers: authHeaders(),
    body
  });

  return { data, error: error ? error : undefined };
}